import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { Input, Button, message, Typography } from "antd";
import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";
import { useTranslation } from "react-i18next";
import HomeButton from "../components/HomeButton";

const { TextArea } = Input;
const { Title } = Typography;

const TextToSpeech: React.FC = () => {
  const { t } = useTranslation();
  const [audioUrl, setAudioUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleTextToSpeech = async (values: { inputText: string }) => {
    setLoading(true);
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/zhadiger/api/tts-audio`,
        values,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
            "ngrok-skip-browser-warning": "true",
          },
          responseType: "text",
        }
      );

      const responseResult = atob(response.data);
      const byteArray = new Uint8Array(responseResult.length);
      for (let i = 0; i < responseResult.length; i++) {
        byteArray[i] = responseResult.charCodeAt(i);
      }

      const audioBlob = new Blob([byteArray], { type: "audio/wav" });
      const audioUrl = URL.createObjectURL(audioBlob);

      setAudioUrl(audioUrl);
      message.success("Text has been converted to speech!");
    } catch (error) {
      message.error("Error converting text to speech");
      console.error("Error in Text-to-Speech API call:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex justify-between items-center mb-4 ml-4 mt-4">
        <HomeButton />
      </div>
      <div className="max-w-xl mx-auto mt-10 p-6 bg-white border border-gray-200 rounded-lg shadow-md flex-grow">
        <Title level={2} className="text-center font-bold text-gray-700">
          {t("text_to_speech")}
        </Title>

        <Formik initialValues={{ inputText: "" }} onSubmit={handleTextToSpeech}>
          {({ handleSubmit }) => (
            <Form className="space-y-4">
              <Field name="inputText">
                {({ field }: { field: any }) => (
                  <TextArea
                    {...field}
                    placeholder={t("enter_text")}
                    rows={4}
                    disabled={loading}
                    className="p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                )}
              </Field>

              <Button
                type="primary"
                onClick={() => handleSubmit()}
                loading={loading}
                className="w-full bg-blue-500 text-white hover:bg-blue-600 rounded-lg py-2 transition duration-200"
              >
                {t("convertToSpeech")}
              </Button>
            </Form>
          )}
        </Formik>

        {audioUrl && (
          <div className="mt-6 text-center">
            <Title level={4} className="text-gray-600">
              Audio Result:
            </Title>
            <audio controls src={audioUrl} className="w-full mt-3" />
          </div>
        )}
      </div>
    </>
  );
};

export default TextToSpeech;
